import { defineFcm } from '../shared/factory';

export const FCM_USER_NPO_CLAIM_REDIRECT_ENABLED = defineFcm('user_npo_claim_redirect_enabled')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-dolphin',
		scope: 'corgi-front-end',
		context: 'Nonprofit Claim Flow',
		description: 'Controls whether claimed nonprofit users are redirected to the success step.',
		import: false,
	});
